import React from "react";
import {
  IconArrowRight,
  IconCertificateOff,
  IconDatabaseOff,
  IconInfoCircle,
} from "@tabler/icons-react";
import Button from "components/Button";
import { useTranslation } from "react-i18next";

const EmptyStateOperationalEnergy = (props: {
  openSettings: () => void;
  isEnergyDashboard?: boolean;
  currentCertification?: string;
  isKeineCertificate?: boolean;
}) => {
  const { t } = useTranslation();

  const showContent = () => {
    if (props.isKeineCertificate && props.isEnergyDashboard) {
      return (
        <div className="max-w-3xl flex flex-col items-center justify-center">
          <IconDatabaseOff className="w-[76px] h-[76px] text-gray-200 mb-4" />
          <span
            className="text-xs font-medium text-gray-500 text-center"
            dangerouslySetInnerHTML={{
              __html: t("operationalEnergy.missingDataMessageKeine"),
            }}
          ></span>
        </div>
      );
    }

    if (props.isEnergyDashboard) {
      return (
        <>
          <IconDatabaseOff className="w-[76px] h-[76px] text-gray-200 mb-4" />
          <span className="text-xs font-medium text-gray-500">
            {t("operationalEnergy.missingData")}
          </span>
          <Button
            type="primary"
            width="fit-content"
            onClick={props.openSettings}
            className="mt-6"
            trailingIcon={<IconArrowRight width={20} />}
          >
            {t("operationalEnergy.openOperationalEmissions")}
          </Button>
        </>
      );
    }

    return (
      <>
        <IconCertificateOff className="w-[76px] h-[76px] text-gray-200 mb-4" />
        <span className="text-xs font-medium text-gray-500">
          {t("operationalEnergy.noCertificationActive")}
        </span>
        <div className="text-indigo-700 text-xs font-medium flex items-center max-w-[490px] my-8">
          <IconInfoCircle
            className="min-w-6 min-h-4 mr-2 bg-indigo-100 rounded-full p-1 text-indigo-600"
            stroke={2.5}
          />
          {t("operationalEnergy.emptyStateDescription")}
        </div>
        <Button type="primary" width="fit-content" onClick={props.openSettings}>
          {t("operationalEnergy.activateOtherCertificates")}
        </Button>
      </>
    );
  };

  return (
    <div className="w-full flex flex-col flex-grow items-center justify-center">
      {showContent()}
    </div>
  );
};

export default EmptyStateOperationalEnergy;
